import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { database } from 'firebase';

@Component({
    selector: 'odl-report-tipo-intervento',
    templateUrl: './report-tipo-intervento.component.html',
    styleUrls: ['./report-tipo-intervento.component.scss']
})
export class ReportTipoInterventoComponent implements OnChanges {

    @Input() data: any;

    public tableData: any = {};

    public barChartOptions: ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        // We use these empty structures as placeholders for dynamic theming.
        scales: { xAxes: [{ stacked: true }], yAxes: [{ stacked: true }] },
        /*
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
            }
        }
        */
    };
    public barChartLabels: Label[] = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
    public barChartType: ChartType = 'bar';
    public barChartLegend = true;
    public barChartPlugins = [];

    public barChartData: ChartDataSets[] = [
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Spurgo vasche', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Bonifica serbatoi', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Lavaggi e disoleatori', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Disinfestazioni', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Prove di tenuta', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Eternit', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Bonifica siti', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Trasporti', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Pulizia p.d.u.', type: 'bar', stack: 'stackid' },
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Altro', type: 'bar', stack: 'stackid' },
    ];


    public pieChartOptions: ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        // We use these empty structures as placeholders for dynamic theming.
        // scales: { xAxes: [{stacked: true}], yAxes: [{stacked: true}] },
        /*
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
            }
        }
        */
    };
    public pieChartLabels: Label[] = ['Spurgo vasche', 'Bonifica serbatoi', 'Lavaggi e disoleatori', 'Disinfestazioni', 'Prove di tenuta', 'Eternit', 'Bonifica siti', 'Trasporti', 'Pulizia p.d.u.', 'Altro'];
    public pieChartType: ChartType = 'pie';
    public pieChartLegend = true;
    public pieChartPlugins = [];

    public pieChartData: ChartDataSets[] = [
        { data: [0,0,0,0,0,0,0,0,0,0] }
    ];


    constructor() { }

    ngOnChanges(changes: { [s: string]: SimpleChange }) {
        console.log('qualcosa è cambiato', changes);
        if (!changes.data.currentValue) {
            this.data = {};
        }
        this.setTable();
    }

    setTable() {
        console.log(this.data);
        this.tableData = {
            totale_mese: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            totale_anno: 0,
        };
        Object.keys(this.data).forEach(key => {
            this.tableData[key] = this.data[key];
            this.tableData[key].forEach((val, idx) => {
                this.tableData.totale_mese[idx] += parseInt(val, 0);
                this.tableData.totale_anno += parseInt(val, 0);
            })

        });

        this.barChartData[0].data = this.data.spurgo_vasche || [];          // 0 - Spurgo vasche
        this.barChartData[1].data = this.data.bonifica_serbatoi || [];      // 1 - Bonifica serbatoi
        this.barChartData[2].data = this.data.lavaggi_disoleatori || [];    // 2 - Lavaggi e disoleatori
        this.barChartData[3].data = this.data.disinfestazioni || [];        // 3 - Disinfestazioni
        this.barChartData[4].data = this.data.prove_tenuta || [];           // 4 - Prove di tenuta
        this.barChartData[5].data = this.data.eternit || [];                // 5 - Eternit
        this.barChartData[6].data = this.data.bonifica_siti || [];          // 6 - Bonifica siti
        this.barChartData[7].data = this.data.trasporti || [];              // 7 - Trasporti
        this.barChartData[8].data = this.data.pulizia_pdu || [];            // 8 - Pulizia p.d.u.
        this.barChartData[9].data = this.data.altro || [];                  // 9 - Altro

        this.pieChartData = [
            {
                data: [
                    this.data.spurgo_vasche ? this.data.spurgo_vasche.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.bonifica_serbatoi ? this.data.bonifica_serbatoi.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.lavaggi_disoleatori ? this.data.lavaggi_disoleatori.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.disinfestazioni ? this.data.disinfestazioni.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.prove_tenuta ? this.data.prove_tenuta.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.eternit ? this.data.eternit.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.bonifica_siti ? this.data.bonifica_siti.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.trasporti ? this.data.trasporti.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.pulizia_pdu ? this.data.pulizia_pdu.reduce((sum, current) => sum + current, 0) : 0,
                    this.data.altro ? this.data.altro.reduce((sum, current) => sum + current, 0) : 0,
                ]
            }
        ];
    }
}
